import { create } from 'zustand'
import { persist } from 'zustand/middleware'

/**
 * Tour state — tracks whether the user has completed the tour, the
 * current step index, and whether the overlay is currently open.
 *
 * `completed` is persisted per browser so first-time visitors auto-open
 * the tour but repeat visitors don't get interrupted. Users can always
 * replay via the TourButton in the top nav.
 */
export const useTourStore = create(
  persist(
    (set) => ({
      isOpen: false,
      stepIndex: 0,
      completed: false,

      start: () => set({ isOpen: true, stepIndex: 0 }),
      next: () => set((s) => ({ stepIndex: s.stepIndex + 1 })),
      back: () =>
        set((s) => ({ stepIndex: Math.max(0, s.stepIndex - 1) })),
      goTo: (idx) => set({ stepIndex: idx }),
      close: () => set({ isOpen: false, completed: true }),
      // Skip marks as complete so we don't nag, but preserves step index
      skip: () => set({ isOpen: false, completed: true }),
    }),
    {
      name: 'ct-q2-goals-v2-tour',
      partialize: (state) => ({ completed: state.completed }),
    }
  )
)
